module.exports = __webpack_public_path__ + "img/avatar7.198adb18.png";